import { rest, graphql } from 'msw'
import { SelfSubmittedMatchUpInput } from 'types/api/types'
import { getClassicApiEndpoint, getWebRootUrl } from 'constants/api'
import apiResponse, { helpers } from './data'
import { getSocialMatches, getTournamentAndResultsPaginated } from './data-objects'
import { MatchUpSubmissionStateEnum, WorldTennisNumberTypeEnum } from 'types/api/enums'
const CLASSIC_USER_API = getClassicApiEndpoint() + 'v2/User'
export const getAuthTokenEndpoint = `${getWebRootUrl()}/Account/Tokens`
export const getCurrentUserEndpoint = `${CLASSIC_USER_API}/GetCurrentUser`
export const getFastTrackDetailsEndpoint = `${CLASSIC_USER_API}/GetRegistrationDetails`
const getAllPersonDetails = `${CLASSIC_USER_API}/GetRegistrationDetailsForCurrentuser`
export const activateUserEndpoint = `${CLASSIC_USER_API}/ActivateItfUser`

const restHandlers = [
  rest.get(getAuthTokenEndpoint, (req, res, ctx) => {
    //return res(ctx.set('x-api-token', 'mockAuthToken'))
    return res(ctx.status(401))
  }),
  rest.get(getCurrentUserEndpoint, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        ID: 'testAnalytics1234',
        Status: 1,
        ExternalID: 'TES123456',
      })
    )
  }),
  rest.get(getFastTrackDetailsEndpoint, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(helpers.createFastTrackDetails()))
  }),
  rest.get(getAllPersonDetails, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        id: '6c540c72-5649-43a4-b5e7-034bfd022aa2',
        firstName: 'Dominik',
        lastName: 'Forge',
        nationality: 'PRT',
        dob: '1981-07-14',
        gender: 'Male',
      })
    )
  }),
  rest.post(activateUserEndpoint, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ success: 'true' }))
  }),
]

const gqlHandlers = [
  graphql.query('worldTennisNumber', (req, res, ctx) => {
    return res(ctx.data(apiResponse.worldTennisNumber()))
  }),
  graphql.query('getProfile', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getProfile()))
  }),
  graphql.query('getOwnProfile', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getOwnProfile()))
  }),
  graphql.query('getAccountDetails', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getAccountDetails()))
  }),
  graphql.query('getRegistrationDetails', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getRegistrationDetails()))
  }),
  graphql.query('getTournamentAndResults', (req, res, ctx) => {
    const { pageArgs } = req.variables
    const allTournaments = apiResponse.getTournamentAndResults.person.allTournaments.items
    const filteredTournaments = allTournaments.slice(pageArgs.skip, pageArgs.skip + pageArgs.limit)
    const returnData = getTournamentAndResultsPaginated
    //@ts-ignore
    returnData.person.allTournaments.items = filteredTournaments

    return res(ctx.data(returnData))
  }),
  graphql.query('getVsInfo', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getVsInfo))
  }),
  graphql.query('getCommonMatches', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getCommonMatches))
  }),
  graphql.query('commonCompetitorMatches', (req, res, ctx) => {
    return res(ctx.data(apiResponse.commonCompetitorMatches))
  }),
  graphql.query('getAggregatedResultCount', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getAggregatedResultCount()))
  }),
  graphql.query('getRatings', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getRatings()))
  }),
  graphql.query('getEarliestRatings', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getEarliestRatings()))
  }),
  graphql.query('getPlayers', (req, res, ctx) => {
    let {
      pageArgs: { skip, limit },
    } = req.variables
    if (skip === undefined) skip = 0
    const players = apiResponse.getPlayers.publicPersons.items.slice(skip, skip + limit)
    const response = {
      publicPersons: {
        items: players,
        totalItems: apiResponse.getPlayers.publicPersons.items.length,
        __typename: 'PersonList',
      },
    }
    return res(ctx.data(response))
  }),
  graphql.query('getPlayerCount', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getPlayerCount))
  }),
  graphql.query('getPlayerStats', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getPlayerStats()))
  }),
  graphql.query('getWatchlists', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getWatchlists()))
  }),
  graphql.query('getWatchlistPlayers', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getWatchlistPlayers))
  }),
  graphql.query('getBucketMatchups', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getBucketMatchups()))
  }),
  graphql.mutation('updateOwnProfile', (req, res, ctx) => {
    return res(ctx.data(apiResponse.updateOwnProfile()))
  }),
  graphql.mutation('personSubmitPSQ', (req, res, ctx) => {
    return res(ctx.data(apiResponse.personSubmitPSQ))
  }),
  graphql.mutation('addAccount', (req, res, ctx) => {
    return res(
      ctx.data({
        addAccountPerson: {
          registrationToken: 'regToken',
          alreadyItfCustomer: false,
          alreadyRegisteredForService: false,
        },
      })
    )
  }),
  graphql.mutation('updateAccount', (req, res, ctx) => {
    return res(ctx.data(apiResponse.updateAccount(req.variables.personInput)))
  }),
  graphql.query('getSuggestions', (req, res, ctx) => {
    return res(ctx.data(apiResponse.getSuggestions()))
  }),
  graphql.query('getOwnSocialMatches', (req, res, ctx) => {
    const { limit, skip, states } = req.variables
    return res(ctx.data(getSocialMatches(states[0], { limit, skip })))
  }),
  graphql.mutation('approveSocialMatch', (req, res, ctx) => {
    const { id } = req.variables
    const updatedMatch = getSocialMatches(MatchUpSubmissionStateEnum.PENDING, {
      limit: 10,
    }).paginated.items.filter(match => match.id === id)[0]
    return res(
      ctx.data({
        approveSelfSubmittedMatchUp: {
          ...updatedMatch,
          submissionState: MatchUpSubmissionStateEnum.APPROVED,
          updatedAt: new Date().toISOString(),
        },
      })
    )
  }),
  graphql.mutation('rejectSocialMatch', (req, res, ctx) => {
    const { id } = req.variables
    const updatedMatch = getSocialMatches(MatchUpSubmissionStateEnum.PENDING, {
      limit: 10,
    }).paginated.items.filter(match => match.id === id)[0]
    return res(
      ctx.data({
        rejectSelfSubmittedMatchUp: {
          ...updatedMatch,
          submissionState: MatchUpSubmissionStateEnum.REJECTED,
          updatedAt: new Date().toISOString(),
          reviewedBy: { id: 'sdo-mdfonjmasd-nmdgvpndpvn2135-35m-95smso' },
        },
      })
    )
  }),
  graphql.mutation('submitSocialMatch', (req, res, ctx) => {
    const { input } = req.variables as { input: SelfSubmittedMatchUpInput }
    // return res( ctx.status(500))
    return res(
      ctx.data({
        addSelfSubmittedMatchUp: {
          id: 'ansdfoua8732rbno',
          ownerId: 'sdo-mdfonjmasd-nmdgvpndpvn2135-35m-95smso',
          submissionState: MatchUpSubmissionStateEnum.PENDING,
          start: input.start,
          worldTennisNumbers: input.sides
            .map(side => side.players)
            .flat()
            .map(player => ({
              tennisNumber: 24,
              personId: player.personId.identifier,
              type: WorldTennisNumberTypeEnum.SINGLE,
            })),
          winningSide: input.winningSide,
          score: input.score,
          sides: input.sides,
          updatedAt: new Date().toISOString(),
        },
      })
    )
  }),
  graphql.mutation('deleteSocialMatch', (req, res, ctx) => {
    const { id } = req.variables
    return res(
      ctx.data({
        removeSelfSubmittedMatchUp: {
          id,
        },
      })
    )
  }),
  graphql.query('getApprovedMatches', (req, res, ctx) => {
    const { limit, skip } = req.variables
    return res(ctx.data(apiResponse.getApprovedMatches({ limit, skip })))
  }),
]

export const handlers = [...restHandlers, ...gqlHandlers]
